import { ApiService } from '@shared/services/ApiService';
import { PaginationRequestModel } from '@/shared/src/models/Pagination';
import { IMarketplaceService } from '@parents/interfaces/services';
import { BuyBundleResponseModel } from '@parents/models/Marketplace';

export class MarketplaceService extends ApiService implements IMarketplaceService {
  constructor() {
    super('marketplace/parent');
  }

  addBundle(ids: number[]): Promise<BuyBundleResponseModel> {
    return this.post('/bundle/add', { bundleIds: ids });
  }

  getBundles(params: PaginationRequestModel): Promise<any> {
    return this.get('/bundle/get', { params });
  }

  getBundle(id: number): Promise<any> {
    return this.get(`/bundle/get/${id}`);
  }
}
